import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';
import { BASE_REPORTS_URL } from 'SharedDir/backend/endpoints/reports';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const BASE_PROJECTS_URL = `${SERVER_API}/projects`;

export const PROJECT_ENDPOINTS = {
  ...generateCrudEndpoints(BASE_PROJECTS_URL),
  USERS_FOR_CONTACTS(projectId: string) {
    return {
      method: 'GET',
      url: `${BASE_PROJECTS_URL}/${projectId}/users-for-contacts`,
    } as IEndpointData;
  },
  RESTORE(projectId: string): IEndpointData {
    return {
      method: 'POST',
      url: `${BASE_PROJECTS_URL}/${projectId}/restore`,
    };
  },
  FILL(projectId: string, sectionId: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${BASE_PROJECTS_URL}/${projectId}/section/${sectionId.toString()}/fill`,
    };
  },
  FILL_ASYNC(projectId: number, sectionId: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${BASE_PROJECTS_URL}/${projectId.toString()}/section/${sectionId.toString()}/fill-async`,
    };
  },
  TASK_STATUSES: { method: 'GET', url: `${BASE_PROJECTS_URL}/tasks/statuses` } as IEndpointData,
  CREATE_TASK(projectId: string): IEndpointData {
    return {
      method: 'POST',
      url: `${BASE_PROJECTS_URL}/${projectId}/tasks`,
    };
  },
  UPDATE_TASK(projectId: string, taskId: string): IEndpointData {
    return {
      method: 'PUT',
      url: `${BASE_PROJECTS_URL}/${projectId}/tasks/${taskId}`,
    };
  },
  UPDATE_TASK_STATUS(projectId: string, taskId: string): IEndpointData {
    return {
      method: 'PUT',
      url: `${BASE_PROJECTS_URL}/${projectId}/tasks/${taskId}/status`,
    };
  },
  GET_TASKS(id: string) {
    return {
      method: 'GET',
      url: `${BASE_PROJECTS_URL}/${id}/tasks`,
    } as IEndpointData;
  },
  GET_MY_TASKS: {
    method: 'GET',
    url: `${BASE_PROJECTS_URL}/assigned-tasks`,
  } as IEndpointData,
  GET_TASK(projectId: string, taskId: string) {
    return {
      method: 'GET',
      url: `${BASE_PROJECTS_URL}/${projectId}/tasks/${taskId}`,
    } as IEndpointData;
  },
  DELETE_TASK(projectId: string, taskId: string) {
    return {
      method: 'DELETE',
      url: `${BASE_PROJECTS_URL}/${projectId}/tasks/${taskId}`,
    } as IEndpointData;
  },
  GET_ROADMAP_STEPS(projectId: string) {
    return {
      method: 'GET',
      url: `${BASE_PROJECTS_URL}/${projectId}/road-steps`,
    } as IEndpointData;
  },
  GET_ROADMAP_STEP(projectId: string, roadStepId: string) {
    return {
      method: 'GET',
      url: `${BASE_PROJECTS_URL}/${projectId}/road-steps/${roadStepId}`,
    } as IEndpointData;
  },
  CREATE_ROADMAP_STEP(projectId: string) {
    return {
      method: 'POST',
      url: `${BASE_PROJECTS_URL}/${projectId}/road-steps`,
    } as IEndpointData;
  },
  ADD_ROADMAP_STEP(projectId: string) {
    return {
      method: 'POST',
      url: `${BASE_PROJECTS_URL}/${projectId}/road-steps/add`,
    } as IEndpointData;
  },
  UPDATE_ROADMAP_STEP(projectId: string, roadStepId: string) {
    return {
      method: 'PUT',
      url: `${BASE_PROJECTS_URL}/${projectId}/road-steps/${roadStepId}`,
    } as IEndpointData;
  },
  DONE(projectId: string, roadStepId: string): IEndpointData {
    return {
      method: 'POST',
      url: `${BASE_PROJECTS_URL}/${projectId}/road-steps/${roadStepId}/done`,
    };
  },
  APPROVE(projectId: string, roadStepId: string): IEndpointData {
    return {
      method: 'POST',
      url: `${BASE_PROJECTS_URL}/${projectId}/road-steps/${roadStepId}/approve`,
    };
  },
  DELETE_ROAD_STEP(projectId: string, roadStepId: string): IEndpointData {
    return {
      method: 'DELETE',
      url: `${BASE_PROJECTS_URL}/${projectId}/road-steps/${roadStepId}`,
    };
  },
  GET_TASK_COMMENTS(projectId: string, taskId: number): IEndpointData {
    return {
      method: 'GET',
      url: `${BASE_PROJECTS_URL}/${projectId}/tasks/${taskId}/comments`,
    };
  },
  SAVE_TASK_COMMENT(projectId: string, taskId: string): IEndpointData {
    return {
      method: 'POST',
      url: `${BASE_PROJECTS_URL}/${projectId}/tasks/${taskId}/comments`,
    };
  },
  WATCH_TASK(projectId: string, taskId: string): IEndpointData {
    return {
      method: 'POST',
      url: `${BASE_PROJECTS_URL}/${projectId}/tasks/${taskId}/spectators`,
    };
  },
  UNWATCH_TASK(projectId: string, taskId: string): IEndpointData {
    return {
      method: 'DELETE',
      url: `${BASE_PROJECTS_URL}/${projectId}/tasks/${taskId}/spectators`,
    };
  },
  GET_FOLDERS(projectId: string): IEndpointData {
    return {
      method: 'GET',
      url: `${BASE_PROJECTS_URL}/${projectId}/folders`,
    };
  },
  GET_FOLDER(projectId: string, folderId: string): IEndpointData {
    return {
      method: 'GET',
      url: `${BASE_PROJECTS_URL}/${projectId}/folders/${folderId}`,
    };
  },
  CREATE_FOLDER(projectId: string): IEndpointData {
    return {
      method: 'POST',
      url: `${BASE_PROJECTS_URL}/${projectId}/folders`,
    };
  },
  UPDATE_FOLDER(projectId: string, folderId: string): IEndpointData {
    return {
      method: 'PUT',
      url: `${BASE_PROJECTS_URL}/${projectId}/folders/${folderId}`,
    };
  },
  DELETE_FOLDER(projectId: string, folderId: string): IEndpointData {
    return {
      method: 'DELETE',
      url: `${BASE_PROJECTS_URL}/${projectId}/folders/${folderId}`,
    };
  },
  CREATE_DOCUMENT(projectId: string): IEndpointData {
    return {
      method: 'POST',
      url: `${BASE_PROJECTS_URL}/${projectId}/documents`,
    };
  },
  DELETE_DOCUMENT(projectId: string, documentId: string): IEndpointData {
    return {
      method: 'DELETE',
      url: `${BASE_PROJECTS_URL}/${projectId}/documents/${documentId}`,
    };
  },
  UPDATE_DOCUMENT(projectId: string, documentId: string): IEndpointData {
    return {
      method: 'PUT',
      url: `${BASE_PROJECTS_URL}/${projectId}/documents/${documentId}`,
    };
  },
  UPDATE_STATUS(projectId: string): IEndpointData {
    return {
      method: 'PUT',
      url: `${BASE_PROJECTS_URL}/${projectId}/update-status`,
    };
  },
  SET_RESPONSIBLE(projectId: string): IEndpointData {
    return {
      method: 'POST',
      url: `${BASE_PROJECTS_URL}/${projectId}/responsible`,
    };
  },
  REPORTS: {
    REGISTRY: {
      method: 'GET',
      url: `${BASE_REPORTS_URL}/project/registry`,
    } as IEndpointData,
    REGISTRY_FOND: {
      method: 'GET',
      url: `${BASE_REPORTS_URL}/project/fondugra`,
    } as IEndpointData,
    //  Формирование отчета мониторинга ГЧП проектов.
    PARTNERSHIP_MONITORING_GCP: {
      method: 'GET',
      url: `${BASE_REPORTS_URL}/projects/partnership-monitoring`,
    } as IEndpointData,
    // Дорожная карта
    PROJECT_ROADMAP(projectId: number): IEndpointData {
      return {
        method: 'GET',
        url: `${BASE_REPORTS_URL}/project/${projectId}/road-map`,
      };
    },
    // Услуги проекта
    PROJECT_ISSUES(projectId: number): IEndpointData {
      return {
        method: 'GET',
        url: `${BASE_REPORTS_URL}/projects/${projectId}/issues`,
      };
    },
    // Паспорт
    PROJECT_PASSPORT(projectId: number): IEndpointData {
      return {
        method: 'GET',
        url: `${BASE_REPORTS_URL}/projects/${projectId}/form`,
      };
    },
    // KPI
    PROJECT_PASSPORT_KPI(projectId: number): IEndpointData {
      return {
        method: 'GET',
        url: `${BASE_REPORTS_URL}/projects/${projectId}/kpi`,
      };
    },
  },
  JOIN_CHAT(projectId: string): IEndpointData {
    return {
      method: 'POST',
      url: `${BASE_PROJECTS_URL}/${projectId}/chat/join`,
    };
  },
  GET_MEMBERS(projectId: string): IEndpointData {
    return {
      method: 'GET',
      url: `${BASE_PROJECTS_URL}/${projectId}/members`,
    };
  },
};
